<template>
  <div class="about">
    <h1 aria-live="assertive">This is an about page</h1>
  </div>
</template>
